import { render } from "./company-comment.vue?vue&type=template&id=275b9486"
import script from "./company-comment.vue?vue&type=script&lang=js"
export * from "./company-comment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__